import * as React from 'react';
import styled from 'styled-components';
import informationSvg from '../../../images/information.svg';
import { tabletPortraitMinWidth, whiteColour, cardInnerGap } from '../../cssConstants';
import { NewCardDescription, NewCardTitle } from './CardLayout';

const PasswordRequirement = () => {
	return (
		<PasswordRequirementWrapper>
			<Img src={informationSvg} alt="i" />
			<TextContainer>
				<NewCardTitle>Password requirements</NewCardTitle>
				<NewCardDescription>
					Passwords must be: at least 10 characters long, with at least one uppercase letter, one lowercase letter, and
					one digit.
				</NewCardDescription>
			</TextContainer>
		</PasswordRequirementWrapper>
	);
};

export default PasswordRequirement;

const PasswordRequirementWrapper = styled.div`
	background-color: ${whiteColour};
	font-size: 12px;
	margin: 10px 0;
	padding: 10px;
	border-radius: 10px;
	display: flex;
	align-items: flex-start;
	gap: 10px;

	@media (min-width: ${tabletPortraitMinWidth}) {
		font-size: 14px;
	}
`;

const TextContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${cardInnerGap};
`;

const Img = styled.img`
	width: 18px;
	height: 18px;
`;
